import {Component, ElementRef, Injector, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ChartComponent} from '../chart.component';
import {NGSIResult} from '../../../models/ngsi/ngsi-result';
import {DataSeries} from '../../../models/visualization/data-series.model';
import {AxisSettings} from '../../../models/visualization/axis-settings.model';
import {DataFormatUtil} from '../../../utils/data-format-util';

import domtoimage from 'dom-to-image';

@Component({
  selector: 'uruk-metric',
  templateUrl: './metric.component.html',
  styleUrls: ['./metric.component.scss']
})
export class MetricComponent extends ChartComponent implements OnInit, OnDestroy {

  // The value of the data
  @Input() data: any;

  // The unit of the data
  @Input() unit: any;

  // reference to the DOM element
  @ViewChild('metric', { read: ElementRef }) metricChart:ElementRef;

  constructor(private injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  setData(data: NGSIResult[]) {
    const chartData = this.dataExtractionUtil.extractData(this.kpi, this.chartSettings, data)[0];
    if (chartData.length > 0) {
      const seriesData = chartData[0];
      if (seriesData.data.length > 0 && this.chartSettings.seriesSettings.length > 0) {
        const value = seriesData.data[0];
        const chartSeries: AxisSettings = this.chartSettings.seriesSettings[0];
        const kpiSeries: DataSeries = this.kpi.series[chartSeries.index];

        this.data = DataFormatUtil.formatValue(value, kpiSeries.format, chartSeries.precision, chartSeries.thousandSeparator);
        this.unit = kpiSeries.unit;
      }
    }
  }

  exportImage() {
    const node = this.metricChart.nativeElement;
    domtoimage.toPng(node, {
      style: {
        'background': 'rgba(39, 39, 39, 0.6)'
      }
    })
    .then((dataUrl) => {
      this.downloadFile(dataUrl, this.panelTitle + '.png');
    })
    .catch(function (error) {
      console.error(error);
    });
  }

  exportCSV() {
    if (this.data) {
      const csvData = this.panelTitle + '\n' + this.data + '\n';

      // download csv file
      // add a BOM as first characters in the file to force Excel to use UTF-8
      this.downloadFile('data:text/csv;charset=utf-8,%EF%BB%BF' + csvData, this.panelTitle + '.csv');
    }
  }

  defaultChartOptions(): any {
  }

  responsiveChartOptions(): any {
  }
}
